import type { FaireProductEntity } from "../../entity_types/product";

export const p_8c4swy4shz: FaireProductEntity = {
  token: "p_8c4swy4shz",
  type: "product",
  name: "Small B&W Tila Bead Hoop Earrings Gold-Plated, Handmade",
  brandToken: "b_b2bdf14e",
  brandName: "Nest Pretty Things",
  imageUrl:
    "https://cdn.faire.com/fastly/70419d8cb38bc1c8cfc77d18f9f0e64f0b1fdad5b36fe3dc83c91a41d80e06e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e26ba4022d598f92da6252de3d254fc6302e1a68b2edb9f4828400f6caf84892.jpeg",
    "https://cdn.faire.com/fastly/7cc3f5e7f95290d53b0231fd1fc46e6eaaab75e66164c5caf58d2400779cbcb6.jpeg",
    "https://cdn.faire.com/fastly/9a00274d809b741db6a50240df12a4eae7d4dc53046e9597d470884a62fbb278.jpeg",
    "https://cdn.faire.com/fastly/a30c3bf4dd8e391f52409851cfb764976778de070b8a72d979eaa1005ca221f6.jpeg",
    "https://cdn.faire.com/fastly/566d018986c0e0e8afe8cb803002222fbe97438fef83758cb578dcc1b604ba82.jpeg",
    "https://cdn.faire.com/fastly/5a3ba4a3d0d6e236e94f8ec0cdeecc6f846ac5f901fc2389f920584d8d3a90df.jpeg",
  ],
  priceDollars: 22,
  description:
    'Our own original design! Beautifully handcrafted statement hoop earrings—Tila Bead Hoop Earrings are an original Nest Pretty Things design. Measuring 0.75" round, each hoop is fitted with high-quality Japanese Tila beads arranged in a mix of bold black and white and colors on a gold-plated metal base.\n\nLightweight and eye-catching, they’re an easy add-on item your customers will love for gifting or everyday wear.\n\nDetails:\n• 0.75" 24K Gold-plated hoops\n• Japanese Tila beads in assorted colors\n• Unique Nest Pretty Things design\n\nGreat for boutiques looking for colorful, feel-good jewelry that sells year-round.',
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:43.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
